'use client';

import { useTrackingCode } from 'react-hubspot-tracking-code-hook';

import Container from '@src/components/Shared/Container';
import RenderBodyCopy from '@src/components/Shared/RenderBodyCopy';
import HubSpotLegacyForm from '@src/components/Sections/HubSpotLegacyForm';

import constructURL from '@src/utils/constructURL';
import usePreviewContent from '@src/hooks/usePreviewContent';

import { DownloadInfoPackPageClientPropTypes } from './DownloadInfoPackPage.types';

const DownloadInfoPackPageClient: React.FC<DownloadInfoPackPageClientPropTypes> = ({ data }) => {
  // Enable live updates for the post
  const page = usePreviewContent({ content: data?.page });

  // Set the page view path for analytics tracking
  const { setPathPageView, setContentType } = useTrackingCode();
  setPathPageView(
    constructURL({
      languageCode: page?.languageCode?.toLowerCase(),
      slug: `/download-info-pack`,
      baseURL: '',
    })
  );

  setContentType('site-page');

  return (
    <>
      <Container className='lg:px-0 pt-[10rem] lg:max-w-7xl xl:px-[0rem]!'>
        <h1 className='text-header-copy text-[3.2rem] font-medium lg:text-[3.8rem]'>
          {page?.pageName}
        </h1>
        <div>
          <HubSpotLegacyForm
            portalId={page?.contactForm?.items?.[0]?.portalId}
            formId={page?.contactForm?.items?.[0]?.formId}
            redirectUrl={page?.contactForm?.items?.[0]?.redirectTo}
            className='valdHsFormBlock'
          />

          <RenderBodyCopy
            className='heading-[1.8rem] pt-[1.6rem] text-[1.2rem] font-normal md:w-[75%]'
            bodyCopy={page?.contactForm?.items?.[0]?.bodyCopy?.json?.content}
          />
        </div>
      </Container>
    </>
  );
};

export default DownloadInfoPackPageClient;
